import { render, staticRenderFns } from "./MenuAprovacao.vue?vue&type=template&id=24c09c97&"
import script from "./MenuAprovacao.vue?vue&type=script&lang=js&"
export * from "./MenuAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports